import { createI18n } from 'vue-i18n'
import sl from './locales/sl'

// Slovenian only (spec decision #14): the product ships a single locale.
export type AvailableLocales = 'sl'

/**
 * Slovenian has four plural forms: 1 (101, 201…), 2, 3–4, and the rest.
 * Messages use the order "ednina | dvojina | 3–4 | množina".
 */
const slPlural = (choice: number, choicesLength: number): number => {
    if (choicesLength < 4) return choice === 1 ? 0 : 1
    const n = Math.abs(choice) % 100
    if (n === 1) return 0
    if (n === 2) return 1
    if (n === 3 || n === 4) return 2
    return 3
}

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           'sl',
    fallbackLocale:   'sl',
    messages:         { sl },
    availableLocales: ['sl'],
    pluralRules:      { sl: slPlural },
})

export default i18n
